import { createSlice } from '@reduxjs/toolkit';

export const typeDocumentSlice = createSlice({
  name: 'typedocument',
  initialState: {
    type_documents_list: [],
    type_documents_list_select: [],
  },
  reducers: {
    setTypeDocumentRedux: (state, { payload }) => {
      state.type_documents_list = payload;
    },
    setTipoDocumentoSelectRedux: (state, { payload }) => {
      state.type_documents_list_select = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setTypeDocumentRedux, setTipoDocumentoSelectRedux } = typeDocumentSlice.actions;
